module.exports = __webpack_public_path__ + "static/media/book_of_dead.playngo.622efd57.jpeg";